import { Field } from 'formik';
import { FormikField } from '~/components/common/FormikField';

export function MachineTokenFormFields() {
  return (
    <Field name="description" label="Description" component={FormikField} />
  );
}
